module.exports = __webpack_public_path__ + "img/Regatta-Logo.6b5d3a4a.jpg";